'use client';
import { jsx } from 'react/jsx-runtime';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { StepIndicatorContext } from './step-indicator-context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(t, e) {
    if (null == t) return {};
    var r, o, n = _object_without_properties_loose(t, e);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(t);
        for(o = 0; o < i.length; o++)r = i[o], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
    }
    return n;
}
function _object_without_properties_loose(t, e) {
    if (null == t) return {};
    var r, o, n = {}, i = Object.keys(t);
    for(o = 0; o < i.length; o++)r = i[o], e.indexOf(r) >= 0 || (n[r] = t[r]);
    return n;
}
const StepIndicator = renderWithRef('StepIndicator', null, (r, p)=>{
    useComponentStylesLoaded('StepIndicator', SWAN_STYLE_KEY_MAP.stepIndicator);
    let { currentStepNumber: s = 1, showAllSteps: c = false } = r, a = _object_without_properties(r, [
        "currentStepNumber",
        "showAllSteps"
    ]), l = new Set([
        'swan-step-indicator'
    ]);
    return c && l.add('swan-step-indicator-show-all-steps'), jsx(StepIndicatorContext.Provider, {
        value: {
            currentStepNumber: s
        },
        children: jsx(RenderComp, {
            root: "div",
            forwardedRef: p,
            classNames: l,
            props: a,
            children: r.children
        })
    });
});

export { StepIndicator };
